/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, MenuButton, FluentProvider, webLightTheme, Menu, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';

import { shimButtonProps, shimMenuProps, MenuItemShim } from '@fluentui/react-migration-v8-v9';

export const ActionButtonShimInternal = React.forwardRef((props, _ref) => {
  const variantProps = {
    ...props,
    variantClassName: 'ms-Button--action ms-Button--command',
  };

  const shimProps = shimButtonProps(variantProps);

  return <Button {...props} {...shimProps} appearance="transparent" />;
});

export const ActionButtonWithMenuShimInternal = React.forwardRef((props, _ref) => {
  const variantProps = {
    ...props,
    variantClassName: props.primary ? 'ms-Button--primary' : 'ms-Button--default',
  };

  const shimProps = {
    ...shimButtonProps(variantProps),
  };

  const shimmedMenuProps = props.menuProps ? shimMenuProps(props.menuProps) : {};


  return (
    <Menu {...shimmedMenuProps}>
      <MenuTrigger>
        <MenuButton {...shimProps} {...props} appearance="transparent" />
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          {props.menuProps && props.menuProps.items && props.menuProps.items.map(item => (
            // key is added through item spread
            // eslint-disable-next-line react/jsx-key
            <MenuItemShim {...item} />
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
});

ActionButtonWithMenuShimInternal.propTypes = {
  menuProps: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  primary: PropTypes.bool,
};

ActionButtonWithMenuShimInternal.defaultProps = {
  menuProps: undefined,
  primary: false,
};

const CommandButtonInternal = (props) => {
  if (props.menuProps) {
    return (
      <ActionButtonWithMenuShimInternal {...props} />
    );
  }

  return (
    <ActionButtonShimInternal {...props} />
  );
};

CommandButtonInternal.propTypes = {
  menuProps: PropTypes.shape({}),
};

CommandButtonInternal.defaultProps = {
  menuProps: undefined,
};

export const CommandButton = CommandButtonInternal;
